import { useMemo } from "react";
import { useAppSelector } from "@store";

export const DIMENSION_P = "dimensions-P";

export const useIsPOriginProject = () => {
  const { currentProject } = useAppSelector((state) => state.project);
  const isPOriginProject = useMemo(() => {
    if (!currentProject) return false;
    const { dataSource: { name: dataSourceName } = {} } = currentProject;
    return dataSourceName === DIMENSION_P;
  }, [currentProject]);

  return {
    isPOriginProject,
  };
};
